import {lazy} from '@aboutyou/lazy-imports';
import {CheckoutAnimation} from '@aboutyou/logic-components';
import React from 'react';

const CheckoutPageLazy = lazy(
  () =>
    import('./CheckoutPage.eager').then(mod => ({
      default: mod.CheckoutPageEager,
    })),
  {
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);

export const CheckoutPage = () => {
  return (
    <>
      <CheckoutAnimation.Begin type="fancy-animation" />
      <CheckoutPageLazy />
    </>
  );
};
CheckoutPage.preload = CheckoutPageLazy.preload;
